<template>
	<main id="main">
		<PartnerFilter @toggle-filter="toggleFilter(false)" />
		<PartnerList @toggle-filter="toggleFilter(true)" />
	</main> 
</template>

<script setup>
import PartnerList from "./PartnerList.vue"
import PartnerFilter from "./PartnerFilter"

const toggleFilter = (flag) => {
	var sideMenu = document.getElementById('sideMenu');
	if (flag) { //open filter
		sideMenu.style.transition = 'left 0.5s';
		sideMenu.style.left = '0';
	} else { //close filter
		sideMenu.style.left = '-450px';
	}
}
</script>
<style scoped src="@/assets/css/pc/account.css">
</style>